type Props = {
  width?: number
  height?: number
  fill?: string
  ariaLabel?: string
}

export function FacebookIcon({
  width = 22,
  height = 22,
  fill = '#ffffff',
  ariaLabel = 'Facebook',
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 10.0609C20 4.50383 15.5234 0 10 0C4.47656 0 0 4.50383 0 10.0609C0 15.0835 3.65625 19.2454 8.4375 20V12.9691H5.89844V10.0609H8.4375V7.84437C8.4375 5.32325 9.92969 3.93005 12.2148 3.93005C13.3086 3.93005 14.4531 4.12655 14.4531 4.12655V6.60248H13.1914C11.9492 6.60248 11.5625 7.37866 11.5625 8.17449V10.0609H14.3359L13.8926 12.9691H11.5625V20C16.3438 19.2454 20 15.0835 20 10.0609Z"
        fill={fill}
      />
    </svg>
  )
}
